import React from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from '@mui/material';
import { department } from 'services/department-service';
import * as departmentService from 'services/department-service';
import { useTranslation } from 'react-i18next';

interface IProps {
    open: boolean;
    onClose: (updatedDepartment?: department) => void;
    tenantId: string;
}

const DepartmentCreateModal = (props: IProps) => {
    const { t } = useTranslation();
    const {
        open,
        onClose,
        tenantId
    } = props;
    const [departmentName, setDepartmentName] = React.useState<string>('');

    const handleCreate = () => {
        departmentService.addDepartment(departmentName, tenantId).then((res) => {
            onClose(res);
        });
    }

    return (
        <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth={'sm'}>
            <DialogTitle>{t('departments.new')}</DialogTitle>
            <DialogContent>
                <Box
                    sx={{ paddingTop: '0.50rem', height: 'fit-content' }}
                >
                    <TextField
                        label={t('departments.name')}
                        value={departmentName}
                        onChange={(e) => setDepartmentName(e.target.value)}
                        fullWidth
                        size='small'
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' color='cancel' onClick={() => onClose()}>{t('buttons.cancel')}</Button>
                <Button variant='contained' color='success' onClick={handleCreate}>{t('buttons.save')}</Button>
            </DialogActions>
        </Dialog>
    )
};

export default DepartmentCreateModal;